export default __webpack_public_path__ + "static/media/johnny_rockets.19ad77d2.webp";